<div class="status-container" [style.color]="getTextColor()">
    {{ statusText }}
    <div class="icon">
        <mat-icon>{{ getIcon() }}</mat-icon>
    </div>
</div>